import React from "react";
import { motion } from "framer-motion";

const Contact = () => {
    // Animation Variants
    const fadeIn = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    const slideInLeft = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <div>
            {/* Contact Us Section with Google Map */}
            <motion.div
                className="bg-secondary flex flex-col md:flex-row w-full p-8 md:p-24 gap-8"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeIn}
            >
             <motion.div
    className="bg-white text-secondary p-8 md:p-12 rounded-md shadow-2xl flex flex-col gap-6 w-full md:w-1/2"
    variants={slideInLeft}
>
    <h2 className="text-3xl md:text-4xl font-playfair-display text-primary">
        Contact Us
    </h2>
    <form className="flex flex-col gap-4">
        <motion.input
            type="text"
            placeholder="Your Name"
            className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
            whileFocus={{ scale: 1.05 }}
        />
        <motion.input
            type="email"
            placeholder="Phone Number"
            className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
            whileFocus={{ scale: 1.05 }}
        />
        <motion.select
            className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
            whileFocus={{ scale: 1.05 }}
        >
            <option value="" disabled>
                Select Enquiry Type
            </option>
            <option value="Auto">Auto</option>
            <option value="Residential">Residential</option>
            <option value="Commercial">Commercial</option>
        </motion.select>
        <motion.textarea
            placeholder="Your Message"
            rows="4"
            className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
            whileFocus={{ scale: 1.05 }}
        ></motion.textarea>
        {/* Upload File Option */}
        <motion.input
            type="file"
            className="p-4 rounded-md bg-accent placeholder-primary font-nunito-sans focus:outline-none"
            whileFocus={{ scale: 1.05 }}
        />
        <motion.button
            type="submit"
            className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-secondary transition"
            whileHover={{ scale: 1.1 }}
        >
            Send Message
        </motion.button>
    </form>
    {/* Phone Number and Call Button */}
    <div className="flex flex-col gap-4 mt-6">
        <p className="text-lg font-nunito-sans text-primary">
            Or call us directly at:
        </p>
        <motion.a
            href="tel:+1234567890"
            className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-secondary transition text-center"
            whileHover={{ scale: 1.1 }}
        >
            Call Us: +1 (234) 567-890
        </motion.a>
    </div>
</motion.div>
                <motion.div
                    className="w-full md:w-1/2 h-[400px] md:h-auto rounded-md overflow-hidden"
                    variants={slideInRight}
                >
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.9117585816803!2d-74.0793424!3d40.719959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c251286563b1bb%3A0xffb05b1b9b0463ac!2sBob&#39;s%20Glass%20Works!5e0!3m2!1sen!2sus!4v1743046596956!5m2!1sen!2sus"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        title="Google Map"
                    ></iframe>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default Contact;